import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {BaseComponent} from "./pages/base.component";
import {BaseRoutingModule} from "./base-routing.module";
import {MatSidenavModule} from "@angular/material/sidenav";
import {LeftMenuComponent} from "./pages/left-menu/left-menu.component";
import {MatIconModule, MatIconRegistry} from "@angular/material/icon";
import {RouterModule} from "@angular/router";
import {UserModule} from "../user/user.module";
import {DomSanitizer} from "@angular/platform-browser";
import {NotfoundComponent} from './pages/notfound/notfound.component';
import {DashboardModule} from "../dashboard/dashboard.module";
import {FormsModule} from "@angular/forms";
import {MatSelectModule} from "@angular/material/select";

export const MY_FORMATS = {
  parse: {
    dateInput: 'DD/MM/YYYY',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@NgModule({
  declarations: [BaseComponent, LeftMenuComponent, NotfoundComponent],
  imports: [
    CommonModule,
    MatSidenavModule,
    MatIconModule,
    RouterModule,
    BaseRoutingModule,
    UserModule,
    DashboardModule,
    FormsModule,
    MatSelectModule
  ],
})
export class BaseModule {
  constructor(private matIconRegistry: MatIconRegistry, private domSanitizer: DomSanitizer) {
    this.matIconRegistry.addSvgIcon(
      'bar-chart-ic',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/bar-chart-ic.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'settings-ic',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/settings-ic.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'users-ic',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/users-ic.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'bookmark-ic',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/bookmark-ic.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'exit-ic',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/exit-ic.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'star-ic',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/star-ic.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'calendar-ic',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/calendar-ic.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'pie-chart-ic',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/pie-chart-ic.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'fork-knife-ic',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/fork-knife-ic.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'reward-ic',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/reward-ic.svg')
    );
  }
}
